import { inject } from 'vue';

/**
 * Composable for accessing authentication state and methods.
 * 
 * This composable provides a centralized way to inject authentication-related
 * properties and methods that are provided by App.vue, eliminating the need
 * for repetitive inject() calls in every component.
 * 
 * @returns {Object} Authentication state and methods
 * @property {Ref<string|null>} authToken - The current authentication token
 * @property {Ref<string|null>} username - The current username
 * @property {Ref<boolean>} isAdmin - Whether the backend confirmed admin access
 * @property {Function} login - Function to log in a user
 * @property {Function} logout - Function to log out the current user
 */
export function useAuth() {
    const authToken = inject('authToken');
    const username = inject('username');
    const isAdmin = inject('isAdmin');
    const login = inject('login');
    const logout = inject('logout');

    return {
        authToken,
        username,
        isAdmin,
        login,
        logout,
    };
}
